import React from "react";
import { connect } from "react-redux";
import { getWidgetSpecificIsVisible, formatDateFromDDMMYYYY, formatTimeSlot } from "@utils/index";
import { resolvePath } from "@utils/resolvePath";
import HomeIcon from "@public/images/icons/home.svg";
import CalendarIcon from "@public/images/Calender.svg";
import {
  Card,
  TopSection,
  IconContainer,
  StatusIcon,
  StatusIconImage,
  StatusText,
  Separator,
  DeliverySection,
  DeliveryIconContainer,
  DeliveryLabel,
  DeliveryDateTime,
  DeliveryDetailsLink,
} from "./styles";

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    ),
  };
};

const normalizeIconSrc = (iconSrc?: string) => {
  if (!iconSrc) return "";
  let path = iconSrc.trim();
  if (path.startsWith("public/")) {
    path = path.slice("public".length);
  } else if (path.startsWith("/public/")) {
    path = path.slice("/public".length);
  }
  if (!path.startsWith("/")) {
    path = `/${path}`;
  }
  return path;
};

const TrackingDetailsCard = (props: any) => {
  const {
    is_visible,
    shipping_status_text,
    delivery_by_label,
    delivery_date,
    delivery_time,
    iconSrc,
    actions,
  } = props;

  if (!is_visible) return <></>;

  const { on_delivery_details_click } = actions || {};

  const formattedDate = formatDateFromDDMMYYYY(delivery_date || "");
  const formattedTime = formatTimeSlot(delivery_time || "");
  const displayDateTime = formattedDate && formattedTime 
    ? `${formattedDate}, ${formattedTime}`
    : formattedDate || formattedTime || "";

  const resolvedIconSrc = normalizeIconSrc(iconSrc);

  const handleDeliveryDetailsClick = () => {
    if (on_delivery_details_click && Array.isArray(on_delivery_details_click)) {
      on_delivery_details_click.forEach((action: any) => {
        if (action && typeof action.funCall === "function") {
          action.funCall(action.args || {});
        }
      });
    }
  };

  return (
    <Card>
      <TopSection>
        <IconContainer>
          <StatusIcon>
            {resolvedIconSrc ? (
              <StatusIconImage
                src={resolvePath(resolvedIconSrc)}
                alt=""
              />
            ) : (
              <HomeIcon width={51} height={51} />
            )}
          </StatusIcon>
        </IconContainer>
        <StatusText>{shipping_status_text}</StatusText>
      </TopSection>
      <Separator />
      <DeliverySection>
        <DeliveryIconContainer>
          <CalendarIcon width={42} height={42} />
        </DeliveryIconContainer>
        <div>
          <DeliveryLabel>{delivery_by_label}</DeliveryLabel>
          <DeliveryDateTime>{displayDateTime}</DeliveryDateTime>
        </div>
      </DeliverySection>
      <DeliveryDetailsLink onClick={handleDeliveryDetailsClick}>
        Delivery details
      </DeliveryDetailsLink>
    </Card>
  );
};

export default connect(mapStateToProps)(TrackingDetailsCard);

